import { render, staticRenderFns } from "./TimezoneSetting.vue?vue&type=template&id=1ed4c5e6"
import script from "./TimezoneSetting.vue?vue&type=script&lang=js"
export * from "./TimezoneSetting.vue?vue&type=script&lang=js"
import style0 from "./TimezoneSetting.vue?vue&type=style&index=0&id=1ed4c5e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports